<div class="modal fade" id="kt_modal_update_bid_unit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Update Bid Unit</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="bidUnitForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Model -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Model</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Model"
                readonly
              />
            </div>

            <!-- Make -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Make</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="company_name"
                placeholder="Make"
                readonly
              />
            </div>

            <!-- Group -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Group</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="group"
                placeholder="Group"
                readonly
              />
            </div>

            <!-- Number of Units -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Number of Units</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="number_of_units"
                placeholder="Enter number of units"
                [class.is-invalid]="isFieldInvalid('number_of_units')"
              />
              <div *ngIf="isFieldInvalid('number_of_units')" class="invalid-feedback">
                {{ getFieldError('number_of_units') }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer p-3">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            [disabled]="isLoading"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="bidUnitForm.invalid || isLoading"
          >
            <span *ngIf="!isLoading">Update</span>
            <span *ngIf="isLoading">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Updating...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
